import request from '@/utils/request'

export function getOptions() {
  return request({
    url: '/api/an/worker/getReportOptions',
    method: 'get'
  })
}

export function addExpenseAccount(data) {
  return request({
    url: '/ea/engineer/addExpenseAccount',
    method: 'post',
    params: { data: data }
  })
}

export function getStateOptions() {
  return request({
    url: '/ea/engineer/getStateOptions',
    method: 'get'
  })
}

export function getList(data) {
  return request({
    url: '/ea/engineer/getList',
    method: 'get',
    params: { data: data }
  })
}

export function exportEngineerData(data) {
  return request({
    url: '/ea/engineer/export-excel',
    method: 'get',
    params: { data: data }
  })
}

export function updateExpenseAccount(data) {
  return request({
    url: '/ea/engineer/updateExpenseAccount',
    method: 'post',
    params: { data: data }
  })
}

export function applyExpenseAccount(data) {
  return request({
    url: '/ea/engineer/applyExpenseAccount',
    method: 'post',
    params: { data: data }
  })
}

export function cancelApplyExpenseAccount(data) {
  return request({
    url: '/ea/engineer/cancelApplyExpenseAccount',
    method: 'post',
    params: { data: data }
  })
}

export function deleteDraftExpenseAccount(data) {
  return request({
    url: '/ea/engineer/deleteDraftExpenseAccount',
    method: 'post',
    params: { data: data }
  })
}

export function getQuotationList(data) {
  return request({
    url: '/ea/quotation/getList',
    method: 'get',
    params: { data: data }
  })
}

export function saveQuotationPdf(data) {
  return request({
    url: '/ea/quotation/savePdf',
    method: 'post',
    data: { data: data }
  })
}

export function switchMonthly(data) {
  return request({
    url: '/ea/quotation/switchMonthly',
    method: 'post',
    data: { data }
  })
}

export function exportDetails(data) {
  return request({
    url: '/ea/quotation/exportDetails',
    method: 'get',
    params: { data: data }
  })
}




// WEBPACK FOOTER //
// ./src/api/ea.js